<template>
    <div>
        <div id="myChart2" class="myChart" style="width:95%;margin:0 auto;"></div>
    </div>
</template>
<script>

export default {
    props: ['tem'],
    data() {
        return {
            name: [8, 9, 34, 55, 88, 72],
            num: [5, 20, 36, 10, 18, 32],
            date: [],
            pulseList: [],
            centList: [],
            imgUrl: '',
            myChart: ''
        }
    },
    watch: {
        tem: function (newVal) {
            // console.log('监视到发生改变', newVal);
            if (newVal) {
                setTimeout(() => {
                    this.echart()
                }, 100)
            }
        }
    },
    mounted() {
        this.echart()
    },
    methods: {
        echart() {
            if (this.tem) {
                this.date = this.tem.map(item => item.nurseDate);
                // echart脉搏数据
                this.pulseList = this.tem.map(item => item.pulse);
                // echart体温数据
                this.centList = this.tem.map(item => item.centigrade);
            }
            // console.log(this.date);
            const colors = ['#5470C6', '#91CC75',];
            this.myChart = this.$echarts.init(document.getElementById('myChart2'))
            let option = {
                color: colors,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                grid: {
                    right: '20%'
                },
                legend: {
                    data: ['脉搏(次/分)', '体温(℃)',]
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: {
                            alignWithLabel: true
                        },
                        // prettier-ignore
                        data: this.date
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '脉搏(次/分)',
                        position: 'left',
                        alignTicks: true,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: colors[0]
                            }
                        },
                        // axisLabel: {
                        //     formatter: '{value} ml'
                        // }
                    },
                    {
                        type: 'value',
                        name: '体温(℃)',
                        position: 'right',
                        alignTicks: true,
                        // offset: 10,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: colors[1]
                            }
                        },
                        // axisLabel: {
                        //     formatter: '{value} ml'
                        // }
                    },
                ],
                series: [
                    {
                        name: '脉搏(次/分)',
                        type: 'line',
                        data: this.pulseList,
                        animation: false,
                    },
                    {
                        name: '体温(℃)',
                        type: 'line',
                        yAxisIndex: 1,
                        data: this.centList,
                        animation: false,
                    },
                ]
            }
            this.myChart.setOption(option, true)
            this.imgUrl = this.myChart.getDataURL();
            // console.log(this.imgUrl);
            // 向父组件传递了两个值
            this.$emit('getImgData', this.imgUrl);
        },
    }
}
</script>
<style scoped>
.myChart {
  width: 600px;
  height: 300px;
  margin-top: 20px;
}
</style>